import { useLanguageContext } from "../../../../context/LanguageContext";
import VersteijnenConfigsPage from "../../../../pages/integrations/versteijnen/VersteijnenConfigsPage";
import { useVersteijnenConfigsRouteValidator } from "../../../validators/integrations/versteijnen/VersteijnenConfigsRouteValidator";
import { RouteConfig } from "../../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useVersteijnenConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/versteijnen")
    .setLabel(translate("eva.main.entities.versteijnen_config"))
    .setValidator(useVersteijnenConfigsRouteValidator())
    .setPage(<VersteijnenConfigsPage />);
}

export default useVersteijnenConfigsRouteConfig;